export default function validateEmail(email: string, regExp: RegExp) {
  return regExp.test(email);
}
